import Card from '@/components/Card';

import { currentProjects, ongoingProjects } from '@/contexts/Projects';

export default function Projects() {
  return (
    <div className='min-h-screen py-16 text-left'>
      <h1 className='font-sans text-sm font-bold md:text-xl'>My</h1>
      <h1 className='font-sans text-3xl font-bold md:text-5xl'>Projects</h1>
      <p className='mt-4 font-serif text-sm md:text-base'>
        This page shows my active and finished projects
      </p>
      <section>
        <div className='py-4'>
          <h2 className='mb-4 font-sans text-2xl font-bold text-left md:text-3xl'>
            On Going Projects
          </h2>
          <div className='py-4'>
            <div className='flex flex-col gap-4 md:grid md:grid-cols-2 xl:grid-cols-3'>
              {ongoingProjects.map((card) => (
                <Card
                  key={card.title}
                  title={card.title}
                  description={card.description}
                  reflink={card.link}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className='py-4'>
          <h2 className='mb-4 font-sans text-2xl font-bold text-left md:text-3xl'>
            Current Projects
          </h2>
          <div className='py-4'>
            <div className='flex flex-col gap-4 md:grid md:grid-cols-2 xl:grid-cols-3'>
              {currentProjects.map((card) => (
                <Card
                  key={card.title}
                  title={card.title}
                  description={card.description}
                  reflink={card.link}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
